import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a31f748"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inventory-body" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot orange-gradient" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot yellow-gradient" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot orange-gradient" })
], -1))
const _hoisted_4 = { class: "pretitle" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot orange-gradient" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot yellow-gradient" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dot yellow-gradient" })
], -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderBarComponent',
  props: {
    title: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1),
      _hoisted_5
    ])
  ]))
}
}

})